"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchEntitlementStatus = exports.SupportedBillingSystemsEnum = void 0;
var SupportedBillingSystemsEnum;
(function (SupportedBillingSystemsEnum) {
    SupportedBillingSystemsEnum["HAMS"] = "HAMS";
    SupportedBillingSystemsEnum["CCP"] = "CCP";
    SupportedBillingSystemsEnum["OPSGENIE"] = "OPSGENIE";
    SupportedBillingSystemsEnum["BACK_OFFICE"] = "BACK_OFFICE";
})(SupportedBillingSystemsEnum || (exports.SupportedBillingSystemsEnum = SupportedBillingSystemsEnum = {}));
var SearchEntitlementStatus;
(function (SearchEntitlementStatus) {
    SearchEntitlementStatus["ACTIVE"] = "ACTIVE";
    SearchEntitlementStatus["INACTIVE"] = "INACTIVE";
})(SearchEntitlementStatus || (exports.SearchEntitlementStatus = SearchEntitlementStatus = {}));
